// extracted by mini-css-extract-plugin
module.exports = {"section":"quote-columns-module--section--2i7hi","quote":"quote-columns-module--quote--2nItJ","author":"quote-columns-module--author--1FFPJ"};